import {
  FASTING_START_TIME_MAP,
  TIME_BREAKFAST,
  TIME_DINNER,
  TIME_LUNCH,
} from '@src/constants';
import { IStateContextData } from '@src/interfaces/state.interfaces';

export const getActualFastingStartTime = (data: IStateContextData) => {
  const { BREAKFAST, DINNER, LUNCH } = FASTING_START_TIME_MAP;

  const breakfastTime = BREAKFAST[data.time_breakfast || TIME_BREAKFAST.SKIP];
  const lunchTime = LUNCH[data.time_lunch || TIME_LUNCH.SKIP];
  const dinnerTime = DINNER[data.time_dinner || TIME_DINNER.SKIP];

  return dinnerTime || lunchTime || breakfastTime;
};
